(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["rj-victoria-hero-v3"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const normalizeMoneyDisplay = (value) => String(value ?? '')
      .trim()
      .replace(/([.,])00$/, '')
      .replace(/,/g, '.');

    const fallbackMoneyDisplay = (value) => {
      const numericValue = Number(value);
      if (!Number.isFinite(numericValue)) return '';

      const moneyValue = numericValue / 100;
      return Number.isInteger(moneyValue)
        ? String(moneyValue)
        : moneyValue.toFixed(2).replace(/0+$/, '').replace(/\.$/, '');
    };

    const syncVariantPricing = (detail) => {
      const variant = detail?.variant;
      if (!variant || variant.available === false) return;

      const priceValue = Number(variant.price);
      const compareValue = variant.compareAtPrice == null ? null : Number(variant.compareAtPrice);
      const priceDisplay = normalizeMoneyDisplay(variant.priceFormatted) || fallbackMoneyDisplay(priceValue);
      const compareDisplay = normalizeMoneyDisplay(variant.compareAtPriceFormatted) || fallbackMoneyDisplay(compareValue);

      if (!priceDisplay) return;

      const hasDiscount = Number.isFinite(priceValue)
        && Number.isFinite(compareValue)
        && compareValue > priceValue
        && Boolean(compareDisplay);
      const savingsValue = hasDiscount ? Math.round((compareValue - priceValue) / 100) : null;

      document.querySelectorAll('[data-v3-root]').forEach((root) => {
        const currentPrice = root.querySelector('[data-rj-v3-price-current]');
        const comparePrice = root.querySelector('[data-rj-v3-price-compare]');
        const saving = root.querySelector('[data-rj-v3-price-saving]');
        const savingAmount = saving?.querySelector('[data-rj-v3-saving-amount]');
        const stickyCta = root.querySelector('[data-v3-sticky-cta]');
        const stickyLabel = root.querySelector('[data-rj-v3-sticky-label]');

        if (currentPrice) currentPrice.textContent = priceDisplay;

        if (comparePrice) {
          comparePrice.hidden = !hasDiscount;
          if (hasDiscount) comparePrice.textContent = `${compareDisplay} دج`;
        }

        if (saving) {
          saving.hidden = !hasDiscount;
          if (hasDiscount && savingAmount) savingAmount.textContent = String(savingsValue);
        }

        if (stickyCta && stickyLabel) {
          const suffix = stickyCta.dataset.rjV3StickySuffix || '';
          const stickyText = `${priceDisplay} دج${suffix ? ` ${suffix}` : ''}`;
          stickyLabel.textContent = stickyText;
          stickyCta.setAttribute('aria-label', stickyText);
        }
      });

      document.querySelectorAll('[data-rj-v3-offer-price]').forEach((offerPrice) => {
        offerPrice.textContent = `${priceDisplay} دج فقط`;
      });

      document.querySelectorAll('[data-rj-v3-offer-compare]').forEach((offerCompare) => {
        offerCompare.hidden = !hasDiscount;
        if (hasDiscount) offerCompare.textContent = compareDisplay;
      });
    };

    const initializeVictoriaV3 = () => {
      document.querySelectorAll('[data-v3-root]').forEach((root) => {
        if (root.dataset.v3Initialized === 'true') return;
        root.dataset.v3Initialized = 'true';

        const mobileViewport = window.matchMedia('(max-width: 680px)');
        root.dataset.activeSlide = '1';

        const trackCta = (placement) => {
          const eventData = {
            product_id: root.dataset.productId,
            slide_number: '1',
            placement,
            landing_version: 'v3'
          };
          if (Array.isArray(window.dataLayer)) window.dataLayer.push({ event: 'rachelle_landing_cta', ...eventData });
          if (typeof window.fbq === 'function') window.fbq('trackCustom', 'RachelleLandingCta', eventData);
        };

        const scrollToOrder = (event, placement) => {
          const order = document.getElementById('VictoriaV3OrderIntro');
          if (!order) return;
          event.preventDefault();
          trackCta(placement);
          order.scrollIntoView({ behavior: 'smooth', block: 'start' });
        };

        const primaryCta = root.querySelector('[data-v3-cta]');
        const stickyCta = root.querySelector('[data-v3-sticky-cta]');
        primaryCta?.addEventListener('click', (event) => scrollToOrder(event, 'hero-v3'));
        stickyCta?.addEventListener('click', (event) => scrollToOrder(event, 'mobile-sticky-v3'));

        const mobileBar = root.querySelector('[data-v3-mobile-bar]');
        if (mobileBar && primaryCta) {
          const orderStart = document.getElementById('VictoriaV3OrderIntro');
          const orderPanel = document.getElementById('VictoriaV3Order');
          const hasOrderArea = Boolean(orderStart && orderPanel);

          let ctaIsAboveViewport = false;
          let orderStartBeforeViewportBottom = false;
          let orderPanelAfterViewportTop = hasOrderArea;
          let ctaStateReady = false;
          let orderStartStateReady = !hasOrderArea;
          let orderPanelStateReady = !hasOrderArea;

          const applyMobileBarVisibility = (shouldShow) => {
            mobileBar.classList.toggle('is-visible', shouldShow);
            mobileBar.setAttribute('aria-hidden', shouldShow ? 'false' : 'true');
            mobileBar.toggleAttribute('inert', !shouldShow);

            if (stickyCta) {
              stickyCta.tabIndex = shouldShow ? 0 : -1;
              stickyCta.setAttribute('aria-disabled', shouldShow ? 'false' : 'true');
            }
          };

          const syncMobileBarVisibility = () => {
            const observerStateReady = ctaStateReady && orderStartStateReady && orderPanelStateReady;
            const orderAreaActive = hasOrderArea
              && orderStartBeforeViewportBottom
              && orderPanelAfterViewportTop;
            const shouldShow = observerStateReady
              && mobileViewport.matches
              && ctaIsAboveViewport
              && !orderAreaActive;

            applyMobileBarVisibility(shouldShow);
          };

          applyMobileBarVisibility(false);

          if ('IntersectionObserver' in window) {
            const ctaObserver = new IntersectionObserver((entries) => {
              const entry = entries[0];
              if (!entry) return;

              ctaIsAboveViewport = !entry.isIntersecting
                && entry.boundingClientRect.bottom < (entry.rootBounds?.top ?? 0);
              ctaStateReady = true;
              syncMobileBarVisibility();
            }, { threshold: 0 });

            ctaObserver.observe(primaryCta);

            if (hasOrderArea) {
              const orderStartObserver = new IntersectionObserver((entries) => {
                const entry = entries[0];
                if (!entry) return;

                const viewportBottom = entry.rootBounds?.bottom ?? window.innerHeight;
                orderStartBeforeViewportBottom = entry.isIntersecting
                  || entry.boundingClientRect.top < viewportBottom;
                orderStartStateReady = true;
                syncMobileBarVisibility();
              }, { threshold: 0 });

              const orderPanelObserver = new IntersectionObserver((entries) => {
                const entry = entries[0];
                if (!entry) return;

                const viewportTop = entry.rootBounds?.top ?? 0;
                orderPanelAfterViewportTop = entry.isIntersecting
                  || entry.boundingClientRect.bottom > viewportTop;
                orderPanelStateReady = true;
                syncMobileBarVisibility();
              }, { threshold: 0 });

              orderStartObserver.observe(orderStart);
              orderPanelObserver.observe(orderPanel);
            }

            const onViewportChange = () => syncMobileBarVisibility();
            if (typeof mobileViewport.addEventListener === 'function') {
              mobileViewport.addEventListener('change', onViewportChange);
            } else {
              mobileViewport.addListener?.(onViewportChange);
            }
          } else {
            let updateFrame = 0;

            const updateFromLayout = () => {
              const ctaRect = primaryCta.getBoundingClientRect();
              let orderAreaActive = false;

              if (hasOrderArea) {
                const startRect = orderStart.getBoundingClientRect();
                const panelRect = orderPanel.getBoundingClientRect();
                orderAreaActive = startRect.top < window.innerHeight && panelRect.bottom > 0;
              }

              applyMobileBarVisibility(
                mobileViewport.matches
                && ctaRect.bottom < 0
                && !orderAreaActive
              );
            };

            const requestLayoutUpdate = () => {
              if (updateFrame) return;
              updateFrame = window.requestAnimationFrame(() => {
                updateFrame = 0;
                updateFromLayout();
              });
            };

            if (typeof mobileViewport.addEventListener === 'function') {
              mobileViewport.addEventListener('change', updateFromLayout);
            } else {
              mobileViewport.addListener?.(updateFromLayout);
            }

            window.addEventListener('scroll', requestLayoutUpdate, { passive: true });
            window.addEventListener('resize', requestLayoutUpdate, { passive: true });
            updateFromLayout();
          }
        }
      });
    };

    initializeVictoriaV3();

    if (!window.__rjVictoriaV3LifecycleBound) {
      window.__rjVictoriaV3LifecycleBound = true;
      document.addEventListener('DOMContentLoaded', initializeVictoriaV3);
      document.addEventListener('shopify:section:load', initializeVictoriaV3);
    }

    if (!window.__rjVictoriaV3PriceSyncBound) {
      window.__rjVictoriaV3PriceSyncBound = true;
      window.addEventListener('rachelle:variant:change', (event) => syncVariantPricing(event.detail));
    }
  })();

  } catch(e) { console.error(e); }
})();
})();
